import React from 'react';
import { formatCurrency, formatDate } from '@ajaibid/utils';
import { Badge } from '@ajaibid/components';

import StockCodeLink from 'Component/StockCodeLink';
import ActionButtons from '../components/ActionButtons';

/**
 * @template T
 * @typedef {import('@ajaibid/components').TableColumnDefinition<T>}  TableColumnDefinition
 */

/**
 * @typedef {import('@services/api/stock/order/dt').OrderDt}  OrderDt
 */

function useColumns() {
  const getTransactionType = (value) => (value === '1' && 'Buy') || (value === '2' && 'Sell') || '';

  /**
   * @type {TableColumnDefinition<OrderDt>[]}
   */
  const columns = [
    {
      path: 'order_time',
      name: 'Waktu',
      renderCell: (ctx) => formatDate(ctx.getValue(), 'HH.mm'),
      size: 80,
    },
    {
      path: 'transaction_type',
      name: 'Aksi',
      renderCell: (ctx) => <Badge type="Order" orderVariant={getTransactionType(ctx.getValue())} />,
      size: 80,
    },
    {
      path: 'stock',
      name: 'Aset',
      renderCell: (ctx) => <StockCodeLink code={ctx.getValue()} />,
      size: 100,
    },
    {
      path: 'lot_input',
      name: 'Lot',
      size: 80,
    },
    {
      path: 'price_order',
      name: 'Price',
      renderCell: (ctx) => formatCurrency(ctx.getValue(), 'IDR'),
      size: 120,
    },
    {
      path: 'total_price',
      name: 'Total',
      renderCell: (ctx) => formatCurrency(ctx.getValue(), 'IDR'),
      size: 160,
    },
    {
      path: 'status_description',
      name: 'Status',
      size: 160,
    },
    {
      name: '',
      action: true,
      renderCell(ctx) {
        return <ActionButtons order={ctx.row.original} />;
      },
    },
  ];

  return columns;
}

export default useColumns;
